import React, { useEffect } from "react";
import { Pagetitle } from "../Components/Pagetitle";
import { Servicesinage } from "../Components/Servicesinage";

export const Services = () => {
  useEffect(() => {
    document.title = "Digital Signage | Products";
  });

  return (
    <>
      <Pagetitle {...{ name: "Products" }} />
      <div className="site-main">
        <section
          className="prt-row about-section clearfix service-cot"
          style={{ paddingBottom: "18px" }}
        >
          <div className="container">
            <div className="row text-center">
              <div className="section-title">
                <div className="title-header ">
                  <h2 className="title " style={{ fontSize: "30px" }}>
                    Constantly Innovating with Experts in the Field of Design,
                    Manufacture and Installation.
                  </h2>
                </div>
              </div>
            </div>
            <Servicesinage />
          </div>
        </section>
      </div>
    </>
  );
};
